export const selectorTheme = state => state.theme.type;
